import { z } from 'zod';
import { calendarDateSchema } from '@/features/listing-filters/calendarDate';

export const OPT_OUT_SCOPE_TYPES = [
  'Global',
  'InformCampaign',
  'Clinic',
  'Workflow',
  'WorkflowConfiguration',
] as const;

export const OPT_OUT_STATUSES = ['Active', 'Inactive'] as const;

export const OPT_OUT_SOURCES = [
  'PetParentEmailLink',
  'PetParentSmsReply',
  'PetParentPortal',
  'ClinicStaff',
  'OttoAdmin',
] as const;

export const OPT_OUT_CHANNELS = ['Email', 'Sms'] as const;

export const optOutsFiltersSchema = z.object({
  workflowId: z.array(z.string().min(1)).optional().catch(undefined),
  scopeType: z.array(z.enum(OPT_OUT_SCOPE_TYPES)).optional().catch(undefined),
  status: z.array(z.enum(OPT_OUT_STATUSES)).optional().catch(undefined),
  source: z.array(z.enum(OPT_OUT_SOURCES)).optional().catch(undefined),
  channel: z.array(z.enum(OPT_OUT_CHANNELS)).optional().catch(undefined),
  createdFrom: calendarDateSchema.optional().catch(undefined),
  createdTo: calendarDateSchema.optional().catch(undefined),
  target: z.string().min(1).optional().catch(undefined),
});

export type OptOutsFilterValues = z.infer<typeof optOutsFiltersSchema>;

export const optOutsSearchSchema = optOutsFiltersSchema.extend({
  page: z.number().int().min(1).optional().catch(undefined),
});
